/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
Admin Only Tag
********************************************************************************************

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       27th April 2025

*******************************************************************************************/

import React                    from 'react';
import {
    styled,
    Box,
    Typography
}                               from '@mui/material';
import AdminIcon                from '@mui/icons-material/SupervisorAccount';
import { withTranslation }      from './hoc';

const AdminOnlyTagContainer = styled(Box)(({theme}) => ({
    width           : 'fit-content',
    textAlign       : 'center',
    borderRadius    : theme.spacing(0.5),
    paddingLeft     : theme.spacing(1),
    paddingRight    : theme.spacing(1),
    paddingTop      : theme.spacing(0.5),
    paddingBottom   : theme.spacing(0.5),
    background      : theme.palette.error.main, 
    color           : theme.palette.primary.contrastText
}))

export const AdminOnlyTag = withTranslation(({t,children,label}) => {
    return (
        <AdminOnlyTagContainer display="flex" alignItems="center">
            <AdminIcon sx = {{ fontSize: 'inherit'}} />
            <Typography component={Box} sx = {{ color:'inherit', fontSize:'inherit', pl : 0.5}}>
                {children || label || t('components.adminBox.label')}
            </Typography>
        </AdminOnlyTagContainer>
    )
});

export default AdminOnlyTag;